<template>
  <div>
    <div class="topbar">
      <div v-if="!isMobile" class="main-btns">
        <div @click="$router.push('/')" class="main-btn" :class="{'blackfont':$route.path.indexOf('work') > -1 && $route.path.indexOf('details') < 0}">Home</div>
        <div @click="$router.push('/about')" class="main-btn" :class="{'blackfont':$route.path.indexOf('work') > -1 && $route.path.indexOf('details') < 0}">About</div>
        <div @click="$router.push('/work')" class="main-btn" :class="{'blackfont':$route.path.indexOf('work') > -1 && $route.path.indexOf('details') < 0}">Work</div>
      </div>
      <div @click="toggleAnim" class="menu">
        <lottie
          :options="defaultOptions"
          :height="100"
          :width="100"
          v-on:animCreated="handleAnimation"
        />
      </div>
    </div>

    <v-navigation-drawer v-model="drawer" style="background:#000; z-index:1000" right fixed temporary>
      <div class="list-container">
        <div @click="$router.push('/'), toggleAnim()" class="list-item">Home</div>
        <div @click="$router.push('/about'), toggleAnim()" class="list-item">About</div>
        <div @click="$router.push('/work'),toggleAnim()" class="list-item">Work</div>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
import animationData from "./menu-004.json";
import Lottie from "vue-lottie";

export default {
  name: "nav",
  data() {
    return {
      anim: "",
      defaultOptions: { animationData, loop: false, autoplay: false },
      drawer: false
    };
  },
  components: {
    Lottie
  },

  methods: {
    toggleAnim() {
      if (this.drawer == true) {
        this.anim.setDirection(-1);
        this.anim.play();
        this.drawer = false;
      } else {
        this.anim.setDirection(1);
        this.anim.play();
        this.drawer = true;
      }
    },
    handleAnimation: function(anim) {
      this.anim = anim;
    }
  },
  computed: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style>
.main-btns {
  display: flex;
}
.blackfont{
  color:#000 !important;
}
.main-btn {
  padding: 15px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  cursor: pointer;
  margin: 0px 10px;
}
.main-btn:hover::before {
  transform: scaleX(1);
}
.main-btn::before {
  content: "";
  background: #fff;
  height: 2px;
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  transform: scaleX(0);
  transform-origin: 0;
  transition: all 0.3s ease;
}
.list-container {
  margin-top: 65px;
  padding: 20px;
}
.list-item {
  border-bottom: solid 1px #ffffff40;
  color: #fff;
  padding: 10px;
  padding-top: 25px;
  position: relative;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
}
.list-item::before {
  content: "";
  background: #fff;
  width: 2px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  transform: scaleY(0);
  transform-origin: 0, 0;
  transition: all 0.3s ease;
}
.list-item:hover::before {
  transform: scaleY(1);
}
.menu {
  cursor: pointer;
  height: 40px;
  z-index: 100000;
  position: fixed;
  right: 15px;
  width: 40px;
  border-radius: 5px;
  background:#000;
  margin: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.topbar {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  height: 60px;
  width: 100%;
  z-index: 10000;
}
</style>